import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiGet, apiPost, apiRemove } from 'api-service';
import { mapToFrontPlatform } from 'utils';
import { bulletinInfluenceResourcesAdapter } from './bulletinContent.adapters';

export const updateBulletinStatisticsSettings = createAsyncThunk(
  'bulletinExportSettingsReducer/updateBulletinStatisticsSettings',
  async (payload, thunkAPI) => {
    const bulletinExportSettingsState =
      thunkAPI.getState().bulletinExportSettingsReducer;

    const value = {
      statistics: {
        ...bulletinExportSettingsState.statistics,
      },
      newspapers: {
        ...bulletinExportSettingsState.newspapers,
      },
    };

    try {
      const response = await apiPost('/user/user-settings', {
        key: 'bulletin_export_settings',
        value,
      });
      return response.data.result.data.value;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const fetchBulletinExportSettings = createAsyncThunk(
  'bulletinExportSettingsReducer/fetchBulletinExportSettings',
  async (payload, thunkAPI) => {
    try {
      const response = await apiGet('/user/user-settings', {
        key: 'bulletin_export_settings',
      });

      return response.data.result.data.value;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const fetchBulletins = createAsyncThunk(
  'bulletinReducer/fetchBulletins',
  async (params, thunkAPI) => {
    const perPageSettings =
      thunkAPI.getState().settingsReducer?.filters?.public
        ?.pageContentCountSlider?.selectedValue;

    try {
      const response = await apiGet('/bulletin', {
        is_archive: 0,
        get_independent_total: 1,
        per_page: perPageSettings,
        count: perPageSettings,
        page: 1,
        ...params,
      });

      return {
        data: response.data?.result?.data || [],
        total: response.data?.result?.meta?.total || 0,
      };
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const removeBulletin = createAsyncThunk(
  'bulletinReducer/removeBulletin',
  async (_, thunkAPI) => {
    const { selectedBulletinIds } = thunkAPI.getState().bulletinReducer;
    try {
      await apiRemove(`/bulletin/${selectedBulletinIds.join(',')}`);
      return { success: true };
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const fetchBulletinInfluenceResources = createAsyncThunk(
  'bulletinReducer/fetchBulletinInfluenceResources',
  async ({ id }, thunkAPI) => {
    try {
      const response = await apiGet(`/bulletin/v2/${id}/resources`);

      const totalLength = Object.values(response.data?.result?.data).flat()
        .length;

      const modifiedData = Object.fromEntries(
        Object.entries(response.data?.result?.data).map(([key, value]) => [
          mapToFrontPlatform[key],
          value.map((item) =>
            bulletinInfluenceResourcesAdapter(mapToFrontPlatform[key], item)
          ),
        ])
      );

      return {
        data: modifiedData || [],
        total: totalLength || 0,
      };
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const exportWordBulletin = createAsyncThunk(
  'bulletinExportSettingsReducer/exportWordBulletin',
  async (payload, thunkAPI) => {
    const { bulletinId, title } = payload;

    const requestData = {
      bulletin_id: bulletinId,
      title: title,
      template: 'modern',
      no_image: true,
    };

    try {
      const response = await apiPost('/bulletin/v2/export/docx', requestData);
      return response?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
